import React from "react";
import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";

export const KpiCard = ({ label, value, sub, icon: Icon, accent = "navy", testId }) => {
  const accents = {
    navy: "text-navy",
    gold: "text-gold-dark",
    green: "text-emerald-600",
    amber: "text-amber-600",
    red: "text-red-600",
  };
  return (
    <Card
      data-testid={testId}
      className="p-5 rounded-lg border-slate-200 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-200 bg-white"
    >
      <div className="flex items-start justify-between">
        <div>
          <p className="text-xs font-medium uppercase tracking-wide text-slate-500">{label}</p>
          <p className={cn("mt-2 text-3xl font-heading font-extrabold tracking-tight", accents[accent])}>{value}</p>
          {sub && <p className="mt-1 text-xs text-slate-500">{sub}</p>}
        </div>
        {Icon && (
          <div className="rounded-lg bg-navy/5 p-2.5">
            <Icon className={cn("h-5 w-5", accents[accent])} />
          </div>
        )}
      </div>
    </Card>
  );
};

export const SectionCard = ({ title, children, action, className, testId }) => (
  <Card data-testid={testId} className={cn("rounded-lg border-slate-200 shadow-sm bg-white", className)}>
    {title && (
      <div className="flex items-center justify-between border-b border-slate-100 px-6 py-4">
        <h3 className="font-heading text-base font-semibold text-navy tracking-tight">{title}</h3>
        {action}
      </div>
    )}
    <div className="p-6">{children}</div>
  </Card>
);

export const ChartEmpty = ({ icon: Icon, message = "No data yet", height = 280 }) => (
  <div
    className="flex flex-col items-center justify-center text-center rounded-lg border border-dashed border-slate-200 bg-slate-50/50"
    style={{ height }}
    data-testid="chart-empty-state"
  >
    {Icon && <Icon className="h-9 w-9 text-slate-300 mb-3" />}
    <p className="text-sm font-medium text-slate-400">{message}</p>
    <p className="mt-1 text-xs text-slate-400/80">Charts populate automatically as activity is recorded.</p>
  </div>
);

export const PageHeader = ({ title, subtitle, children }) => (
  <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between mb-6">
    <div>
      <h1 className="font-heading text-2xl sm:text-3xl font-extrabold text-navy tracking-tight">{title}</h1>
      {subtitle && <p className="mt-1 text-sm text-slate-500">{subtitle}</p>}
    </div>
    {children && <div className="flex flex-wrap gap-2">{children}</div>}
  </div>
);
